import { Box, Button, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { ReactNode } from 'react';
import React from 'react';

type FilterContainerProps = {
  isOpen: boolean;
  onReset: () => void;
  children: ReactNode;
};

export const FilterContainer: React.FC<FilterContainerProps> = ({ isOpen, onReset, children }) => {
  return isOpen ? (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        width: '100%',
        ml: '16px'
      }}>
      <Stack direction="column">
        <Typography
          variant="subtitle2"
          sx={{
            color: "text.secondary",
            fontSize: '0.75rem',
            lineHeight: '1rem',
            opacity: 0.6
          }}>
          Filter by
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "center",
            mt: 1,
            fontSize: '0.875rem',
            lineHeight: '1.5rem',
            color: 'text.primary'
          }}>
          {children}
        </Stack>
      </Stack>

      <Box sx={{ alignSelf: 'flex-end', mr: '32px' }}>
        <Button
          variant="text"
          sx={{
            color: 'primary.main',
            fontSize: '0.875rem',
            lineHeight: '1.5rem',
            textTransform: 'none',
            fontWeight: 500,
          }}
          startIcon={<VyIcon icon="Back" />}
          onClick={onReset}
        >
          Reset filters
        </Button>
      </Box>
    </Stack>
  ) : null;
};
